export default __webpack_public_path__ + "assets/a6.d7a57947.jpg";